// src/redux/reducers/notificationReducer.js

import { SET_NOTIFICATIONS } from "../actions/notificationActions";

const initialState = {
    list: [], // Toutes les notifications
};

const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_NOTIFICATIONS:
            return {
                ...state,
                list: action.payload.map(n => ({
                    ...n,
                    data: typeof n.data === "string" ? JSON.parse(n.data) : n.data
                }))
            };

        default:
            return state;
    }
};

export default notificationReducer;
